import KeenSlider from 'keen-slider';

const quoteGlider = () => {
	const quotes = document.querySelector('.v-quote-large__wrap');
	const keen = new KeenSlider( // eslint-disable-line no-unused-vars
	quotes,
		{
			loop: true,
			drag: false,
			selector: '.v-quote-large__quote',
			defaultAnimation: {
				duration: 1500,
			},
			detailsChanged: (s) => {
				s.slides.forEach((element, idx) => {
					if (0 < s.track.details.slides[idx].portion) {
						element.style.visibility = 'visible'; // eslint-disable-line no-param-reassign
					} else {
						element.style.visibility = 'hidden'; // eslint-disable-line no-param-reassign
					}
					element.style.opacity = s.track.details.slides[idx].portion; // eslint-disable-line no-param-reassign
				});
			},
			renderMode: 'custom',
		},
		[
			(slider) => {
				let timeout;

				/**
				 * Autoplay.
				 */
				function nextTimeout() {
					clearTimeout(timeout);
					timeout = setTimeout(() => {
						slider.next();
					}, 5000);
				}

				slider.on('created', () => {
					quotes.classList.add('v-quote-large__wrap--loaded');
					nextTimeout();
				});

				slider.on('animationEnded', nextTimeout);
				slider.on('updated', nextTimeout);
			},
		],
	);
};
export default quoteGlider